import { useMemo } from 'react';
import { z } from 'zod';

import { useChannelFieldSchemas } from './channel-refinements';

/**
 * Per-channel `{ budget, duration }` validated against `getChannelDefaults`,
 * **only for channels the user selected** for posting. Unselected channels
 * pass through untouched so cleared inputs there do not block submit.
 */
export function useGeneralRecommendationSchema(
  channelSlugs: string[],
  selectedChannelSlugs: string[],
) {
  const { getBudgetSchema, getDurationSchema } = useChannelFieldSchemas();

  return useMemo(() => {
    const shape = Object.fromEntries(
      channelSlugs.map(slug => [
        slug,
        selectedChannelSlugs.includes(slug)
          ? z.object({
              budget: getBudgetSchema(slug),
              duration: getDurationSchema(slug),
            })
          : z.any(),
      ]),
    );
    return z.object(shape);
  }, [channelSlugs, selectedChannelSlugs, getBudgetSchema, getDurationSchema]);
}
